import { action, makeObservable, observable } from 'mobx';

class CurrencyStore {
    constructor() {
        makeObservable(this)
    }

    @observable loadingItemStatus: boolean = false;
    @action setLoadingItemStatus(status: boolean) {
        this.loadingItemStatus = status;
    }

    // Currencies
    @observable currencies = {}
    @action setCurrencies(currencies: any) {
        this.currencies = currencies;
    }

    @action addCurrency(currencyId: number, currencyData: any) {
        this.currencies[currencyId] = currencyData;
    }

    @action updateCurrency(currencyId: number, currencyData: any) {
        this.currencies[currencyId] = currencyData;
    }

    @action deleteCurrency(currencyId: number) {
        delete this.currencies[currencyId];
    }
    // Currencies
}

const store = new CurrencyStore();

export default store;